import { TrackingEventType } from '../../../addons/adverts/common';
export { JsonAdBreakTrackingEvent } from './ad-breaks-provider.enums';
export var JsonAdBreakTrackingEventMap = {
    BREAK_START: TrackingEventType.BreakStart,
    BREAK_END: TrackingEventType.BreakEnd,
    breakStart: TrackingEventType.BreakStart,
    breakEnd: TrackingEventType.BreakEnd
}; // The home page URL for the verification service provider that supplies the resource file
 // Describes a JavaScript resource used to collect verification data
 // the name of the API framework
 // the uri to this resource
 // Time position in ISO 8601 seconds format, relative to the beginning of the playback session
 // Time position in seconds format, relative to the beginning of the playback session
 // Length in ISO 8601 seconds format
 // Length in seconds format
 // TODO: Parse the data for non linear ads when they are available on Json
 // Time position in ISO 8601 seconds format, relative to the beginning of the playback session
 // Time position in seconds format, relative to the beginning of the playback session
 // Length in ISO 8601 seconds format
 // Length in seconds format
 // Time position in ISO 8601 seconds format, relative to the beginning of the playback session
 // Time position in seconds format, relative to the beginning of the playback session
 // Defined by the VAST spec
 // Current VAST Spec says `adSlotId` but Yospace comply with older spec using `adSlotID`

//# sourceMappingURL=json-ad-breaks.js.map